import {
  CREATE_EMPLOYEE_DEPENDENT_FAIL,
  CREATE_EMPLOYEE_DEPENDENT_REQUEST,
  CREATE_EMPLOYEE_DEPENDENT_SUCCESS,
  DELETE_EMPLOYEE_DEPENDENT_FAIL,
  DELETE_EMPLOYEE_DEPENDENT_REQUEST,
  DELETE_EMPLOYEE_DEPENDENT_SUCCESS,
  GET_EMPLOYEE_DEPENDENT_FAIL,
  GET_EMPLOYEE_DEPENDENT_REQUEST,
  GET_EMPLOYEE_DEPENDENT_SUCCESS,
} from "../../types/shared/dependentType";

export const createDependentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case CREATE_EMPLOYEE_DEPENDENT_REQUEST:
      return {
        ...state,
        createDependentLoading: true,
      };
    case CREATE_EMPLOYEE_DEPENDENT_SUCCESS:
      return {
        ...state,
        createDependentLoading: false,
        createDependentInfo: payload,
        createDependentError: "",
      };
    case CREATE_EMPLOYEE_DEPENDENT_FAIL:
      return {
        ...state,
        createDependentLoading: false,
        createDependentError: payload,
        createDependentInfo: [],
      };
    default:
      return state;
  }
};

export const deleteDependentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case DELETE_EMPLOYEE_DEPENDENT_REQUEST:
      return {
        ...state,
        deleteDependentLoading: true,
      };
    case DELETE_EMPLOYEE_DEPENDENT_SUCCESS:
      return {
        ...state,
        deleteDependentLoading: false,
        deleteDependentInfo: payload,
        deleteDependentError: "",
      };
    case DELETE_EMPLOYEE_DEPENDENT_FAIL:
      return {
        ...state,
        deleteDependentLoading: false,
        deleteDependentError: payload,
        deleteDependentInfo: [],
      };
    default:
      return state;
  }
};

export const getDependentReducers = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_EMPLOYEE_DEPENDENT_REQUEST:
      return {
        ...state,
        getDependentLoading: true,
      };
    case GET_EMPLOYEE_DEPENDENT_SUCCESS:
      return {
        ...state,
        getDependentLoading: false,
        getDependentInfo: payload,
        getDependentError: "",
      };
    case GET_EMPLOYEE_DEPENDENT_FAIL:
      return {
        ...state,
        getDependentLoading: false,
        getDependentError: payload,
        getDependentInfo: [],
      };
    default:
      return state;
  }
};
  